import { render, staticRenderFns } from "./CommonFindings.vue?vue&type=template&id=cb7a419a&"
import script from "./CommonFindings.vue?vue&type=script&lang=js&"
export * from "./CommonFindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports